export const validShareAbleState = (value) => {
  if (!value || !/^[A-Z]{2}$/.test(value)) {
    return 'Invalid state';
  }
};

export default validShareAbleState;
